export default __webpack_public_path__ + "static/media/26-460x460.c149188a.jpeg";